import { useState, useEffect } from 'react';
import './InstallPrompt.css';

export default function InstallPrompt() {
  const [showIOSPrompt, setShowIOSPrompt] = useState(false);
  const [showAndroidPrompt, setShowAndroidPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fermé le prompt
    const promptDismissed = localStorage.getItem('installPromptDismissed');
    
    if (promptDismissed === 'true') {
      return; // Ne rien afficher si l'utilisateur a déjà fermé le message
    }

    // Détecter si c'est un appareil iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator as any).standalone;
    
    // Détecter si c'est Safari sur iOS
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome|CriOS|EdgiOS|FxiOS/.test(navigator.userAgent);
    
    // Afficher le prompt iOS UNIQUEMENT si c'est iOS, Safari, et pas en mode standalone
    if (isIOS && isSafari && !isInStandaloneMode) {
      setShowIOSPrompt(true);
    }

    // Gérer l'événement beforeinstallprompt pour Android/Desktop
    const handleBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowAndroidPrompt(true);
    };

    // Gérer l'événement d'installation (pour masquer le prompt après installation)
    const handleAppInstalled = () => {
      setShowIOSPrompt(false);
      setShowAndroidPrompt(false);
      setDeferredPrompt(null);
      localStorage.setItem('installPromptDismissed', 'true');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('PWA installée');
    }
    
    setDeferredPrompt(null);
    setShowAndroidPrompt(false);
  };

  const handleClose = () => {
    // Mémoriser que l'utilisateur a fermé le message
    localStorage.setItem('installPromptDismissed', 'true');
    setShowIOSPrompt(false);
    setShowAndroidPrompt(false);
  };

  if (showIOSPrompt) {
    return (
      <div className="install-prompt install-prompt-ios">
        <div className="install-prompt-content">
          <button className="install-prompt-close" onClick={handleClose} aria-label="Fermer">
            ×
          </button>
          <div className="install-prompt-icon">📱</div>
          <h3>Installer l'application</h3>
          <p className="install-prompt-info">
            Suivez ces étapes pour installer l'application :
          </p>
          <div className="install-prompt-steps">
            <div className="install-step">
              <span className="step-number">1</span>
              <span>Appuyez sur les <strong>3 points (...)</strong> en bas de Safari</span>
            </div>
            <div className="install-step">
              <span className="step-number">2</span>
              <span>Sélectionnez <strong>"Partager"</strong> <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 5l-1.42 1.42-1.59-1.59V16h-2V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z"/></svg></span>
            </div>
            <div className="install-step">
              <span className="step-number">3</span>
              <span>Faites défiler et appuyez sur <strong>"Plus"</strong> (3 points)</span>
            </div>
            <div className="install-step">
              <span className="step-number">4</span>
              <span>Choisissez <strong>"Ajouter sur l'écran d'accueil"</strong></span>
            </div>
          </div>
          <p className="install-prompt-note">
            <small>Note : Chrome et Edge ne peuvent pas installer d'applications sur iOS</small>
          </p>
        </div>
      </div>
    );
  }

  if (showAndroidPrompt && deferredPrompt) {
    return (
      <div className="install-prompt install-prompt-android">
        <div className="install-prompt-content">
          <button className="install-prompt-close" onClick={handleClose} aria-label="Fermer">
            ×
          </button>
          <div className="install-prompt-icon">📱</div>
          <h3>Installer l'application</h3>
          <p>Installez Mâhî Bâyân sur votre appareil pour un accès rapide et hors ligne.</p>
          <button className="install-prompt-button" onClick={handleInstallClick}>
            Installer maintenant
          </button>
        </div>
      </div>
    );
  }

  return null;
}
